import React from "react";

import Skeleton from "@mui/material/Skeleton";

import { Container, StepDescription } from "./styles";
import ProgressIndicator from "../ProgressIndicator";

const LoadingProgressStep = () => (
  <Container>
    <ProgressIndicator status="pending" />
    <StepDescription>
      <Skeleton width="95px" height="22px" />
      <Skeleton width="85px" height="20px" />
    </StepDescription>
  </Container>
);

export default LoadingProgressStep;
